import { createApi } from '@reduxjs/toolkit/query/react';
import { GuidT, PaginationIF } from '@/types/common';
import { EVENTS_API_TAGS } from '@/api/eventsApi/config';
import {
    AddEventIF,
    EventIF,
    SearchEventIF,
    UpdateEventIF,
} from '@/api/eventsApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const eventsApi = createApi({
    reducerPath: 'eventsApi',
    baseQuery: fetchRestApiQuery('/Events'),
    tagTypes: EVENTS_API_TAGS,
    endpoints: (builder) => ({
        searchEvents: builder.query<PaginationIF<EventIF>, SearchEventIF>({
            query: ({
                entityGuid,
                outfitGuid,
                text,
                searchFromDate,
                searchToDate,
            }) => ({
                url: '',
                params: {
                    EntityGuid: entityGuid,
                    OutfitGuid: outfitGuid,
                    Text: text,
                    SearchFromDate: searchFromDate,
                    SearchToDate: searchToDate,
                },
            }),
            providesTags: ['SearchEvents'],
        }),
        getEventById: builder.query<EventIF, GuidT>({
            query: (id) => `/${id}`,
            providesTags: ['GetEventById'],
        }),
        addEvent: builder.mutation<EventIF, AddEventIF>({
            query: (body) => ({
                url: '',
                method: 'POST',
                body: body,
            }),
            invalidatesTags: ['SearchEvents'],
        }),
        deleteEvent: builder.mutation<boolean, GuidT>({
            query: (eventGuid) => ({
                url: `/${eventGuid}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['SearchEvents'],
            transformResponse() {
                return true;
            },
            transformErrorResponse() {
                return false;
            },
        }),
        updateEvent: builder.mutation<boolean, UpdateEventIF>({
            query: (data) => ({
                url: `/${data.guid}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['SearchEvents', 'GetEventById'],
            transformResponse() {
                return true;
            },
            transformErrorResponse() {
                return false;
            },
        }),
    }),
});
